import {
  Box,
  Typography,
  Link,
  Button,
  Divider,
  Modal,
  List,
  ListItem,
} from "@mui/material";
import router, { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import songStyle from "./styles";
import useCountDown from "../../src/hooks/useCountDown";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import SocialShareComponent from "../Buttons/socialShareReferral";
import auth from "../Layout/util/auth";
import eventBus from "../../util/eventBus";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import TagManager from "react-gtm-module";
import moment from "moment";

const NftCard = ({
  assetTiers,
  Nftprice,
  data,
  isMobile,
  nftLink,
  songName,
  artistName,
}) => {
  console.log(
    "🚀 ~ file: NftCard.js ~ line 26 ~ NftCard ~ assetTiers",
    assetTiers
  );
  console.log("Launch Date", data?.attributes?.lauch_date);
  const countDown1 = useCountDown(data?.attributes?.lauch_date);
  const {
    days: days1,
    hours: hours1,
    minutes: minutes1,
    seconds: seconds1,
    timeDiff1: timeDiff11,
  } = useCountDown(data?.attributes?.lauch_date);

  console.log(
    "Countdown to Launch Date",
    countDown1.days,
    countDown1.hours,
    countDown1.minutes,
    countDown1.timeDiff1
  );
  console.log(
    "🚀 ~ file: NftCard.js ~ line 18 ~ NftCard ~ Nftprice",
    assetTiers?.attributes?.phase_1_start_date
  );
  const [priorityAccess, setPriorityAccess] = useState(false);
  const { days, hours, minutes, seconds, timeDiff1 } = useCountDown(
    assetTiers?.attributes?.phase_1_start_date
  );

  console.log(days1, hours1, minutes1, timeDiff11, "oneone");

  console.log(days, hours, minutes, timeDiff1, "one");
  //  console.log("Countdown to Phase 1 date",countDown2.days, countDown2.hours, countDown2.minutes, countDown2.timeDiff1)

  //  debugger;

  const [wallet, setWallet] = useState(0);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setWallet(localStorage.getItem("walletBalance"));
    }
  }, []);
  const [countLike, setCountLike] = useState({});

  let likeobj = {
    tierId: assetTiers.attributes?.tier_id,
    assetId: assetTiers?.id,
  };

  const { mutate: likeDislike } = useMutation(
    () => fetcher.post(`v1/nft/like`, likeobj),
    {
      onSuccess: (res) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "tokenWishlisted",
            tokenName: data?.attributes?.Title,
            tokenCategory: assetTiers?.attributes?.slug,
            tokenPrice: assetTiers?.attributes?.starting_bid,
            tokenOwnership: assetTiers?.attributes?.revenue_share,
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        setCountLike(res?.[0]);
        console.log("Print Result == ", res);
      },
      onError: (error) => {
        console.log("Print Error == ", error);
      },
    }
  );

  // get Nft likes count
  const { mutate: likeCount } = useMutation(
    () => fetcher.get(`v1/nft/like?assetId=${assetTiers?.id}`),
    {
      onSuccess: (res) => {
        setCountLike(res?.result?.[0]);
      },
      onError: (error) => {
        console.log("Print Error Nft Like count== ", error);
      },
    }
  );

  const { mutate: getProfile } = useMutation(
    (id) => fetcher.get(`/v1/user/${id}`),
    {
      onSuccess: (response) => {
        setPriorityAccess(response?.result?.priorityAccess || false);
      },
      onError: (error) => {
        setNameUpdateError(true);
      },
    }
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      getProfile(localStorage.getItem("userId"));
    }
    likeCount();
  }, []);

  const [open, setOpen] = useState(false);

  // const {walletFund} = useSelector(state=>state.walletFund)
  // const dispatch = useDispatch()
  // useEffect(()=> {
  //   console.log("Wallet price ===", walletFund);
  //   dispatch(setWalletFund("my wallet price"));
  // }, walletFund)

  const handleOpenmodal = () => setOpen(true);
  const handleClosemodal = () => setOpen(false);

  //state for success button
  const [count, setCount] = useState(0);
  const max_token_per_user = assetTiers?.attributes?.max_token_per_user || 2;
  // increase counter
  const increase = () => {
    if (count < max_token_per_user) {
      setCount((count) => count + 1);
    } else {
      alert("You can't take more than " + max_token_per_user + " tokens ");
    }
  };

  //decrease counter
  const decrease = () => {
    setCount((count) => count - 1);
  };
  const [nftCardUrl, setNftCardUrl] = useState();

  useEffect(() => {
    const total = count * Nftprice;
    if (typeof window !== "undefined") {
      localStorage.setItem("NftTokens", count);
      localStorage.setItem("TotalnftPrice", total);
    }
  }, [count]);

  const { mutate: BuyNFTApi } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/reserve`, requestBody),
    {
      onSuccess: (res) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "tokenBuynow",
            tokenName: data?.attributes?.Title,
            tokenCategory: assetTiers?.attributes?.slug,
            tokenPrice: assetTiers?.attributes?.starting_bid,
            tokenOwnership: assetTiers?.attributes?.revenue_share,
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        router.push({
          pathname: "/payment/BuyNowNft",
          query: { tier_id: assetTiers?.attributes?.tier_id },
        });
      },
      onError: (error) => {
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );

  const { mutate: ReserveNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/reserve`, requestBody),
    {
      onSuccess: (res) => {
        const tagManagerArgs = {
          dataLayer: {
            event: "tokenReserved",
            tokenName: data?.attributes?.Title,
            tokenCategory: assetTiers?.attributes?.slug,
            tokenPrice: assetTiers?.attributes?.starting_bid,
            tokenOwnership: assetTiers?.attributes?.revenue_share,
          },
        };
        TagManager.dataLayer(tagManagerArgs);
        router.push({
          pathname: "/payment/ReserveNowNft",
          query: { tier_id: assetTiers?.attributes?.tier_id },
        });
      },
      onError: (error) => {
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );
  // const r = auth();
  // const reserveNft = (e,id) => {
  //   e.stopPropagation();
  //   if (r.token) {
  //     var requestBody= {
  //       "tierId":id,
  //       "quantity": 1
  //     }
  //     ReserveNFT(requestBody)
  //   } else {
  //     eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
  //    };
  // }

  const r = auth();
  const { profile, userData } = useSelector((state) => state.user);
  console.log("userData", userData);

  const reserveNft = (e, id) => {
    e.stopPropagation();
    localStorage.setItem("nftAction", "ReserveNFT");
    if (isEmpty(r?.token)) {
      eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
    } else if (isEmpty(userData?.mobile)) {
      if (typeof window != "undefined") {
        localStorage.setItem("tierId", id);
        localStorage.setItem("tokenName", data?.attributes?.Title);
        localStorage.setItem("tokenCategory", assetTiers?.attributes?.slug);
        localStorage.setItem(
          "tokenPrice",
          assetTiers?.attributes?.starting_bid
        );
        localStorage.setItem(
          "tokenOwnership",
          assetTiers?.attributes?.revenue_share
        );
      }
      eventBus.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    } else {
      var requestBody = {
        tierId: id,
        quantity: 1,
      };
      ReserveNFT(requestBody);
    }
  };

  const BuyNft = (e, id) => {
    const tagManagerArgs = {
      dataLayer: {
        event: "tokenBuynow",
        tokenName: data?.attributes?.Title,
        tokenCategory: assetTiers?.attributes?.slug,
        tokenPrice: assetTiers?.attributes?.starting_bid,
        tokenOwnership: assetTiers?.attributes?.revenue_share,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    e.stopPropagation();
    localStorage.setItem("nftAction", "BuyNFT");
    if (isEmpty(r?.token)) {
      eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
    } else if (isEmpty(userData?.mobile)) {
      if (typeof window != "undefined") {
        localStorage.setItem("tierId", id);
        localStorage.setItem("tokenName", data?.attributes?.Title);
        localStorage.setItem("tokenCategory", assetTiers?.attributes?.slug);
        localStorage.setItem(
          "tokenPrice",
          assetTiers?.attributes?.starting_bid
        );
        localStorage.setItem(
          "tokenOwnership",
          assetTiers?.attributes?.revenue_share
        );
      }
      eventBus.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    } else {
      var requestBody = {
        tierId: id,
        quantity: 1,
      };
      // BuyNFTApi(requestBody);
      router.push({
        pathname: "/payment/BuyNowNft",
        query: { tier_id: id },
      });
    }
  };

  const handleLike = (e) => {
    e.stopPropagation();
    if (isEmpty(r?.token)) {
      eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
    } else if (isEmpty(userData?.mobile)) {
      eventBus.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    } else {
      likeDislike();
    }
  };

  const songNft = (e, id) => {
    e.preventDefault();
    const tagManagerArgs = {
      dataLayer: {
        event: "tokenMoreInfo",
        tokenName: data?.attributes?.Title,
        tokenCategory: assetTiers?.attributes?.slug,
        tokenPrice: assetTiers?.attributes?.starting_bid,
        tokenOwnership: assetTiers?.attributes?.revenue_share,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    router.push({
      pathname: `/song-nft/${assetTiers?.attributes?.slug}`,
    });
  };

  const handleShare = (e) => {
    e.stopPropagation();
    console.log("handle share");
    setOpen(true);

    // const tagManagerArgs = {
    //   dataLayer: {
    //      event: 'tokenShared',
    //     tokenName: data?.attributes?.Title,
    //     tokenCategory: assetTiers?.attributes?.slug,
    //     tokenPrice: assetTiers?.attributes?.starting_bid,
    //     tokenOwnership: assetTiers?.attributes?.revenue_share
    //     shareMethod: pass the method used,
    //   }
    // }
    // TagManager.dataLayer(tagManagerArgs);
  };
  // const nftCardLin

  var url;
  useEffect(() => {
    if (typeof window !== "undefined") {
      url = window?.location?.origin?.toString();
    }
    setNftCardUrl(url + `/song-nft/${assetTiers?.attributes?.slug}`);
  }, []);
  const { country_code } = useSelector((state) => state.layout);
  console.log("timeDiff", timeDiff11);
  return (
    <>
      {isMobile ? (
        <Box
          key={assetTiers.id}
          sx={songStyle.mobilePackageBox}
          onClick={(e) => songNft(e, assetTiers?.id)}
        >
          <Box sx={songStyle.packageBox} style={{ margin: "0" }}>
            <Box component="img" src={assetTiers.attributes?.asset_image_url} />
            <Box>
              <Box sx={songStyle.tokenContentTitle}>
                <Typography component="p" sx={songStyle.packageName}>
                  {assetTiers.attributes?.asset_tier_mnemonics}
                </Typography>

                {country_code == "IN" && (
                  <Typography component="p" sx={songStyle.packagePrice}>
                    ₹ {Math.round(assetTiers.attributes?.starting_bid * 80)}
                  </Typography>
                )}
                {country_code == "OTHER" && (
                  <Typography component="p" sx={songStyle.packagePrice}>
                    $ {assetTiers.attributes?.starting_bid}
                  </Typography>
                )}
              </Box>
              <Divider />
              <Typography component="p" sx={songStyle.packageSubTitle}>
                {assetTiers.attributes?.revenue_share}% - Royalty Share | No. of
                NFTs - {assetTiers.attributes?.tier_max_supply}
              </Typography>

              <Box sx={songStyle.benefitListBox}>
                {assetTiers.attributes?.Privilege1 && (
                  <Typography component="p" sx={songStyle.packageBenefitsTitle}>
                    <img src="/images/token/star.png" alt="" />
                    {assetTiers.attributes?.Privilege1}
                  </Typography>
                )}
                {assetTiers.attributes?.Privilege2 && (
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <img src="/images/token/tick-dark.png" alt="" />
                    {assetTiers.attributes?.Privilege2}
                  </Typography>
                )}
                {/* {assetTiers.attributes?.Privilege3 && (
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <img src="/images/token/tick-dark.png" alt="" />
                    {assetTiers.attributes?.Privilege3}
                  </Typography>
                )} */}
              </Box>
              <Link href="#" sx={songStyle.moreInfoLink}>
                More Info
              </Link>
            </Box>
          </Box>
          <Box sx={songStyle.tokenBtn}>
            {assetTiers?.attributes?.phase_1_sold !=
            assetTiers?.attributes?.phase_1_supply ? (
              <>
                {timeDiff11 >= 1 ? (
                  <>
                    {timeDiff1 >= 1 ? (
                      <>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleShare(e)}
                        >
                          <Box component="img" src="/images/nft/upload.svg" />
                        </Button>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleLike(e)}
                        >
                          <Box
                            component="img"
                            src={
                              countLike?.hasLiked
                                ? "/images/nft/heart.svg"
                                : "/images/nft/empty-heart.svg"
                            }
                          />
                          <Typography
                            component="span"
                            sx={songStyle.loveCounter}
                          >
                            {countLike?.likeCount}
                          </Typography>
                        </Button>
                        <Button
                          variant="contained"
                          sx={songStyle.tokenBuyNow}
                          onClick={(e) =>
                            reserveNft(e, assetTiers.attributes?.tier_id)
                          }
                        >
                          Reserve Now
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleShare(e)}
                        >
                          <Box component="img" src="/images/nft/upload.svg" />
                        </Button>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleLike(e)}
                        >
                          <Box
                            component="img"
                            src={
                              countLike?.hasLiked
                                ? "/images/nft/heart.svg"
                                : "/images/nft/empty-heart.svg"
                            }
                          />
                          <Typography
                            component="span"
                            sx={songStyle.loveCounter}
                          >
                            {countLike?.likeCount}
                          </Typography>
                        </Button>
                        {timeDiff1 < 0 ? (
                          <Button
                            variant="contained"
                            sx={songStyle.tokenBuyNow}
                            onClick={(e) => e.stopPropagation()}
                          >
                            Buy Now opens at{" "}
                            {moment(
                              assetTiers?.attributes?.phase_1_start_date
                            ).format(" hh:mm A")}
                            {/* Buy opens at { moment(assetTiers?.attributes?.phase_1_start_date).format("hh A") }  */}
                          </Button>
                        ) : (
                          <>
                            {priorityAccess ? (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) =>
                                  BuyNft(e, assetTiers.attributes?.tier_id)
                                }
                              >
                                Buy Now
                              </Button>
                            ) : moment().diff(
                                moment(
                                  assetTiers?.attributes?.phase_1_start_date
                                ),
                                "minutes"
                              ) > 60 ? (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) =>
                                  BuyNft(e, assetTiers.attributes?.tier_id)
                                }
                              >
                                Buy Now
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                Only Priority Access Open
                              </Button>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Button
                      sx={songStyle.btnUpload}
                      onClick={(e) => handleShare(e)}
                    >
                      <Box component="img" src="/images/nft/upload.svg" />
                    </Button>
                    <Button
                      sx={songStyle.btnUpload}
                      onClick={(e) => handleLike(e)}
                    >
                      <Box
                        component="img"
                        src={
                          countLike?.hasLiked
                            ? "/images/nft/heart.svg"
                            : "/images/nft/empty-heart.svg"
                        }
                      />
                      <Typography component="span" sx={songStyle.loveCounter}>
                        {countLike?.likeCount}
                      </Typography>
                    </Button>
                    {timeDiff1 > 0 ? (
                      <Button
                        variant="contained"
                        sx={songStyle.tokenBuyNow}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {/* {days}{':D '}{hours}{":H "}{minutes}{":M "}{seconds}{":S "}111 */}
                        {console.log(
                          days,
                          hours,
                          minutes,
                          timeDiff1,
                          "1111111"
                        )}
                        Buy Now opens at{" "}
                        {moment(
                          assetTiers?.attributes?.phase_1_start_date
                        ).format(" hh:mm A")}
                      </Button>
                    ) : (
                      <>
                        {priorityAccess ? (
                          <Button
                            variant="contained"
                            sx={songStyle.tokenBuyNow}
                            onClick={(e) =>
                              BuyNft(e, assetTiers.attributes?.tier_id)
                            }
                          >
                            Buy Now
                          </Button>
                        ) : moment().diff(
                            moment(assetTiers?.attributes?.phase_1_start_date),
                            "minutes"
                          ) > 60 ? (
                          <Button
                            variant="contained"
                            sx={songStyle.tokenBuyNow}
                            onClick={(e) =>
                              BuyNft(e, assetTiers.attributes?.tier_id)
                            }
                          >
                            Buy Now
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            sx={songStyle.tokenBuyNow}
                            onClick={(e) => e.stopPropagation()}
                          >
                            Only Priority Access Open
                          </Button>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <Button
                  sx={songStyle.btnUpload}
                  onClick={(e) => handleShare(e)}
                >
                  <Box component="img" src="/images/nft/upload.svg" />
                </Button>
                <Button sx={songStyle.btnUpload} onClick={(e) => handleLike(e)}>
                  <Box
                    component="img"
                    src={
                      countLike?.hasLiked
                        ? "/images/nft/heart.svg"
                        : "/images/nft/empty-heart.svg"
                    }
                    // onClick={() => setCountLike(countLike + 1)}
                  />
                  <Typography component="span" sx={songStyle.loveCounter}>
                    {countLike?.likeCount}
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  sx={songStyle.tokenBuyNow}
                  style={{ background: "#e14084" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  Phase 1 Sold Out
                </Button>
              </>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          key={assetTiers.id}
          sx={songStyle.featuredBox}
          onClick={(e) => songNft(e, assetTiers?.id)}
        >
          <Box sx={songStyle.packageBox} id="nfttoken">
            <Box component="img" src={assetTiers.attributes?.asset_image_url} />
            <Box>
              <Box sx={songStyle.tokenContentTitle}>
                <Typography component="p" sx={songStyle.packageName}>
                  {assetTiers.attributes?.asset_tier_mnemonics}
                </Typography>

                {country_code == "IN" && (
                  <Typography component="p" sx={songStyle.packagePrice}>
                    ₹ {Math.round(assetTiers.attributes?.starting_bid * 80)}
                  </Typography>
                )}
                {country_code == "OTHER" && (
                  <Typography component="p" sx={songStyle.packagePrice}>
                    $ {assetTiers.attributes?.starting_bid}
                  </Typography>
                )}
              </Box>

              <Typography component="p" sx={songStyle.packageSubTitle}>
                {assetTiers.attributes?.revenue_share}% - Royalty Share | No. of
                NFTs - {assetTiers.attributes?.tier_max_supply}
              </Typography>
              <Box sx={songStyle.benefitListBox}>
                {assetTiers.attributes?.Privilege1 && (
                  <Typography component="p" sx={songStyle.packageBenefitsTitle}>
                    <img src="/images/token/star.png" alt="" />
                    {assetTiers.attributes?.Privilege1}
                  </Typography>
                )}
                {assetTiers.attributes?.Privilege2 && (
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <img src="/images/token/tick-dark.png" alt="" />
                    {assetTiers.attributes?.Privilege2}
                  </Typography>
                )}
                {assetTiers.attributes?.Privilege3 && (
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <img src="/images/token/tick-dark.png" alt="" />
                    {assetTiers.attributes?.Privilege3}
                  </Typography>
                )}
              </Box>
              {/* <Typography component="p" sx={songStyle.availToken}>
                {assetTiers.attributes?.tier_current_supply} /
                {assetTiers.attributes?.tier_max_supply} Available
              </Typography> */}
              {/* <Link href="#" sx={songStyle.moreInfoLink}>
                More Info
              </Link> */}
              <Typography sx={songStyle.moreInfoLink}>More Info</Typography>
              {/* <Divider sx={songStyle.dividerLine}/> */}
              <Box sx={songStyle.tokenBtn}>
                {assetTiers?.attributes?.phase_1_sold !=
                assetTiers?.attributes?.phase_1_supply ? (
                  <>
                    {timeDiff11 > 0 ? (
                      <>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleShare(e)}
                        >
                          <Box component="img" src="/images/nft/upload.svg" />
                        </Button>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleLike(e)}
                        >
                          <Box
                            component="img"
                            src={
                              countLike?.hasLiked
                                ? "/images/nft/heart.svg"
                                : "/images/nft/empty-heart.svg"
                            }
                          />
                          <Typography
                            component="span"
                            sx={songStyle.loveCounter}
                          >
                            {countLike?.likeCount}
                          </Typography>
                        </Button>
                        <Button
                          variant="contained"
                          sx={songStyle.tokenBuyNow}
                          onClick={(e) =>
                            reserveNft(e, assetTiers.attributes?.tier_id)
                          }
                        >
                          Reserve Now
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleShare(e)}
                        >
                          <Box component="img" src="/images/nft/upload.svg" />
                        </Button>
                        <Button
                          sx={songStyle.btnUpload}
                          onClick={(e) => handleLike(e)}
                        >
                          <Box
                            component="img"
                            src={
                              countLike?.hasLiked
                                ? "/images/nft/heart.svg"
                                : "/images/nft/empty-heart.svg"
                            }
                          />
                          <Typography
                            component="span"
                            sx={songStyle.loveCounter}
                          >
                            {countLike?.likeCount}
                          </Typography>
                        </Button>
                        {timeDiff1 > 0 ? (
                          <Button
                            variant="contained"
                            sx={songStyle.tokenBuyNow}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {/* {days}{':D '}{hours}{":H "}{minutes}{":M "}{seconds}{":S "}111 */}
                            {console.log(
                              days,
                              hours,
                              minutes,
                              timeDiff1,
                              "1111111"
                            )}
                            Buy Now opens at{" "}
                            {moment(
                              assetTiers?.attributes?.phase_1_start_date
                            ).format(" hh:mm A")}
                          </Button>
                        ) : (
                          <>
                            {priorityAccess ? (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) =>
                                  BuyNft(e, assetTiers.attributes?.tier_id)
                                }
                              >
                                Buy Now
                              </Button>
                            ) : moment().diff(
                                moment(
                                  assetTiers?.attributes?.phase_1_start_date
                                ),
                                "minutes"
                              ) > 60 ? (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) =>
                                  BuyNft(e, assetTiers.attributes?.tier_id)
                                }
                              >
                                Buy Now
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                sx={songStyle.tokenBuyNow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                Only Priority Access Open
                              </Button>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Button
                      sx={songStyle.btnUpload}
                      onClick={(e) => handleShare(e)}
                    >
                      <Box component="img" src="/images/nft/upload.svg" />
                    </Button>
                    <Button
                      sx={songStyle.btnUpload}
                      onClick={(e) => handleLike(e)}
                    >
                      <Box
                        component="img"
                        src={
                          countLike?.hasLiked
                            ? "/images/nft/heart.svg"
                            : "/images/nft/empty-heart.svg"
                        }
                      />
                      <Typography component="span" sx={songStyle.loveCounter}>
                        {countLike?.likeCount}
                      </Typography>
                    </Button>
                    <Button
                      variant="contained"
                      sx={songStyle.tokenBuyNow}
                      style={{ background: "#e14084" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      Phase 1 Sold out
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      <Modal open={open} onClick={() => setOpen(false)}>
        <SocialShareComponent
          style={{ left: "35%", top: "38%" }}
          nftCardUrl={nftCardUrl}
          tokenName={data?.attributes?.Title}
          tokenCategory={assetTiers?.attributes?.slug}
          tokenPrice={assetTiers?.attributes?.starting_bid}
          tokenOwnership={assetTiers?.attributes?.revenue_share}
          tokenType={assetTiers.attributes?.asset_tier_mnemonics}
          songName={songName}
          artistName={artistName}
        />
      </Modal>
    </>
  );
};

export default NftCard;
